import styled from 'styled-components';
import { theme } from '../theme';
import { ActiveInactiveButton, CustomButton } from './Button';
import { CustomLabel } from './CustomLabel';
import { DropdownOverlay } from './CommonComponent';

interface IStyleProps {
  fontSize?: string;
  fontWeight?: string;
  textAlign?: string;
  height?: string;
  maxHeight?: string;
  placeholder?: boolean;
  fromPaymentSystem?: boolean;
}

export const TableContainer = styled.div<IStyleProps>`
  height: inherit;
  table {
    margin-bottom: 0px;
    background: ${theme.palette.common.white};
    border-color: #ddd;
    border-width: ${props => (props.placeholder ? '0px' : '0px 1px 1px')};
    border-style: solid;
    width: 100%;
    border-radius: ${props => (props.placeholder ? '10px' : '0px 0px 10px 10px')};
    border-spacing: 20px;
    table-layout: fixed; // makes table of specific width
    height: ${props => (props.placeholder ? 'inherit' : 'auto')};
  }
  .table-col-5 {
    width: 5% !important;
  }
  .table-col-10 {
    width: 10%;
  }
  .table-col-12 {
    width: 12%;
  }
  .table-col-15 {
    width: 15%;
  }
  .table-col-20 {
    width: 20%;
  }
  .table-col-25 {
    width: 25%;
  }
  .table-col-30 {
    min-width: 300px;
    width: 30%;
  }
  .table-col-35 {
    min-width: 300px;
    width: 35%;
  }
  .table-col-50 {
    min-width: 300px;
    width: 50%;
  }
  .table-col-70 {
    min-width: 300px;
    width: 70% !important;
  }
  .table-col-right {
    text-align: right;
    padding-right: 5%;
  }
  ${ActiveInactiveButton} {
    height: 24px;
    padding: 4px 5px;
    min-width: 90px;
    width: 100px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
  }
  ${CustomButton} {
    height: 24px;
    padding: 4px 6px;
    min-width: 70px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    width: 120px;
  }
  &.default-table {
    .table {
      border: none;
      td {
        border: none;
      }
      tbody {
        height: auto;
        max-height: 200px;
      }
      th {
        font-weight: 400;
        color: #555;
      }
    }
  }

  @media (max-width: 1300px) {
    min-width: 1000px;
    overflow-x: auto;
    padding-right: 30px;
  }
`;

export const THead = styled.thead`
  display: table;
  width: calc(100% - 5px);
  table-layout: fixed;
  /* margin-bottom: 10px; */
`;
export const TableRow = styled.tr`
  display: table;
  width: 100%;
  table-layout: fixed;
  &:hover {
    td {
      background-color: rgb(248, 248, 248);
      cursor: pointer;
    }
  }
`;
export const TableHead = styled.th<IStyleProps>`
  font-size: ${props => props.fontSize || '14px'};
  font-weight: ${props => props.fontWeight || '600'};
  text-align: ${props => props.textAlign || 'left'};
  color: #000;
  border-bottom: 1px solid #ddd;
  padding: 0.5rem;
  white-space: nowrap;
  min-width: 130px;
  /* margin-bottom: 10px; */
  /* width: 100%; */
  &:first-child {
    padding-left: 21px;
    width: 160px;
    &.table-col-20 {
      width: 20%;
    }
  }
`;
export const TBody = styled.tbody<IStyleProps>`
  overflow-y: auto;
  height: ${props => props.height || (props.fromPaymentSystem ? 'calc(100vh - 392px)' : 'calc(100vh - 278px)')};
  // apply {height: calc(100vh - 350px)}, when there is a notification box only to full page tables
  display: inline-block;
  width: 100%;
  &::-webkit-scrollbar {
    width: 0.4em;
    height: 0.4em;
    /* background: rgba(21, 40, 55, 0.3); */
    background: #aaaaaa26;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    outline: 1px solid #ddd;
    background-color: #aaa;
    /* background-color: #00f; */
    border-radius: 10px;
  }
  @media (max-width: 1300px) {
    height: ${props => props.height || 'calc(100vh - 412px)'};
  }
`;

export const TableData = styled.td<IStyleProps>`
  font-size: ${props => props.fontSize || '14px'};
  font-weight: ${props => props.fontWeight || '400'};
  text-align: ${props => props.textAlign || 'left'};
  color: ${props => props.color || '#000'} !important;
  border-bottom: 1px solid #ddd;
  /* width: 100%; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 130px;
  max-width: 100%;
  vertical-align: middle;
  height: 20px;
  /* width: 100%; */
  /* Add below 2 lines if we need to change the grid spacing  */
  /* padding: 0px 10px !important; */
  /* height: 30px; */
  &:first-child {
    padding-left: 21px !important;
    width: 160px;
    &.table-col-20 {
      width: 20%;
    }
  }
  .img-15 {
    height: 15px;
    width: 15px;
    margin-bottom: 4px;
  }
  .img-20 {
    height: 20px;
    width: 20px;
  }
`;
// Table Header Styles
export const TableHeaderWrapper = styled.div`
  background-color: #f8f8f8;
  padding: 15px 20px;
  border-radius: 10px 10px 0px 0px;
  border: 1px solid #ddd;
  .filter-icons {
    display: none; // Hide filter icons, remove it when the functionality is implemented
    img {
      height: 17px;
      width: 17px;
      margin-right: 8px;
      margin-bottom: 3px;
    }
  }
  .filter-section > div {
    > ${CustomLabel} {
      font-size: 12px;
      line-height: 16px;
    }
    > img {
      height: 17px;
      width: 17px;
      margin-right: 8px;
    }
  }
`;
export const FilterGroups = styled.div`
  background-color: #fff;
  padding: 7px 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 12px;
  line-height: 16px;
  min-width: 100px;
  span {
    font-weight: 600;
    margin-left: 8px;
  }
`;
export const SelectedFilter = styled.div`
  background: #fff;
  width: auto;
  min-width: 50px;
  border: 1px solid #aaa;
  border-radius: 20px;
  display: flex;
  gap: 7px;
  align-items: center;
  color: #556bb8;
  padding: 7px 10px;
  height: 30px;
  img:not(.cross-icon) {
    height: 17px;
    width: 17px;
    margin-right: 0px;
  }
  ${CustomLabel} {
    font-size: 12px;
    line-height: 16px;
    color: #556bb8;
  }
  .cross-icon {
    height: 12px;
    width: 12px;
    margin-right: 0px;
    cursor: pointer;
  }
`;

export const PaginationWrapper = styled.div`
  background: #f8f8f8;
  padding: 10px 20px;
  /* height: 36px; */
  color: #000;
  border: 1px solid #ddd;
  border-top: 0px;
  border-radius: 0px 0px 8px 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 0px 0px 10px 10px;
  ${CustomLabel} {
    font-size: 14px;
    line-height: 16px;
    color: #555;
  }
  .pagination {
    margin-bottom: 0px;
    justify-content: center;
  }
  .single-select-wrapper.option-table-select {
    display: none;
    input.searchable-dropdown-input {
      width: 100%;
      border: none;
      border-bottom: 1px solid #ccc;
      border-radius: 0px;
      padding: 0px;
    }
  }
  .page-item {
    border: none;
    background: #f8f8f8;
    padding: 0px 10px;
    .page-link {
      border: none;
      background: #f8f8f8;
      padding: 0px 10px;
      color: #000;
      font-size: 12px;
      font-weight: 400;
      &:focus {
        outline: none;
        box-shadow: none;
      }
    }
  }
  .pg-single-select {
    width: auto;
    font-size: 12px;
    cursor: pointer;
    .header {
      height: 30px;
      border: none;
      width: auto;
      min-width: 40px;
      padding-right: 35px;
      color: #000;
      font-weight: 600;
    }
    .select-header-icon {
      border-left: none;
      height: 26px;
    }
    .fa.fa-solid.fa-caret-down {
      font-size: 20px;
    }
    ${DropdownOverlay} {
      bottom: 0;
      top: unset;
      transform: translate(0px, -29px);
      color: #000;
      border-radius: 4px;
      padding: 5px 10px;
      border: 1px solid #ccc;
      > div {
        max-height: 180px;
      }
      li {
        font-size: 12px;
        line-height: 20px;
      }
    }
  }
  .pg-middle-section {
    ${CustomLabel},i {
      cursor: pointer;
    }
    .disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }
`;
